import { Box, Heading, Text } from '@doist/marketist';
import cn from 'clsx';
import { Button } from 'components/button';
import { Image } from '../image/image';
import { Markup } from '../markup/markup';
import css from '../blog-post.module.css';
export type RichTextCTAProps = {
  title: string;
  description: string;
  button?: {
    text: string;
    href: string;
  };
  illustration: string;
  backgroundColor?: string;
};
export function RichTextCTA({
  title,
  description,
  button,
  illustration,
  backgroundColor
}: RichTextCTAProps) {
  return <Box tag="aside" className={cn('box pb-32 pi-24 md-pi-48', css.cta)} style={backgroundColor ? {
    '--bg-color': backgroundColor
  } : undefined} data-sentry-element="Box" data-sentry-component="RichTextCTA" data-sentry-source-file="rich-text-cta.tsx">
            <Box data-sentry-element="Box" data-sentry-source-file="rich-text-cta.tsx">
                <Heading level="3" size="major-base" data-sentry-element="Heading" data-sentry-source-file="rich-text-cta.tsx">
                    {title}
                </Heading>
                <Text size="body-base" weight="medium" className={cn(css.colorSecondary, 'mbs-16')} data-sentry-element="Text" data-sentry-source-file="rich-text-cta.tsx">
                    <Markup content={description} data-sentry-element="Markup" data-sentry-source-file="rich-text-cta.tsx" />
                </Text>
                {button && <Button className={'mbs-24'} href={button.href}>
                        {button.text}
                    </Button>}
            </Box>
            <Image src={illustration} width={216} height={215} alt="" data-sentry-element="Image" data-sentry-source-file="rich-text-cta.tsx" />
        </Box>;
}